import React, { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import { menuItemsState, useInitializeMenuItems } from '../store/menu.state';
// import useMenuFeatureSettings from '../warehouse/hooks/useMenuFeatureSettings';

// Component to initialize menu items
const AppMenuInitializer: React.FC = () => {
  const setMenuItems = useSetRecoilState(menuItemsState);
  const initialMenuItems = useInitializeMenuItems();
  // const warehouse = useRecoilValue(warehouseSelected);
  // const { applyMenuOrderFromSettings } = useMenuFeatureSettings();
  // const [initialized, setInitialized] = useState(false);

  // Initialize menu items with default values
  useEffect(() => {
    // Log all initial menu items for debugging
    console.log('Initializing menu items:', initialMenuItems);

    // Create deep copies to avoid immutability issues
    const safeMenuItems = initialMenuItems.map(item => ({ ...item }));
    setMenuItems(safeMenuItems);
    // setInitialized(true);
  }, [setMenuItems, initialMenuItems]);

  // Temporarily disabled to fix loading issues
  // Apply saved menu order from warehouse settings
  // useEffect(() => {
  //   // Only attempt to apply menu order when warehouse is selected and items are initialized
  //   if (warehouse && initialized) {
  //     try {
  //       applyMenuOrderFromSettings();
  //     } catch (error) {
  //       console.error('Error applying menu order settings:', error);
  //       // If there's an error, set default menu items
  //       setMenuItems(initialMenuItems);
  //     }
  //   }
  // }, [warehouse, applyMenuOrderFromSettings, initialMenuItems, setMenuItems, initialized]);

  return null; // This component doesn't render anything
};

export default AppMenuInitializer;
